import React, { useContext, useState, useEffect } from 'react';
import {
  StepFourContainer,
  StepFourHeader,
  StepFourHeaderTitle,
  StepFourHeaderStep,
  StepFourHeaderInfo,
  StepFourButtonSimulation,
  StepFourContent,
  StepFourColumn,
  StepFourResultItem,
  StepFourResultItemIcon,
  StepFourResultItemInfo,
  StepFourDisplayResultLabel,
  StepFourDisplayValues,
  StepFourDisplayValuesRow,
  StepFourDisplayValuesRowValue,
  StepFourFooter,
  StepFourFooterLeftSide,
  StepFourFooterRightSide,
  Tooltip,
  TooltipTitle,
  TooltipContent,
  InfoCircleImage
} from './styles';
import { useHistory } from 'react-router';
import { formatPrice } from '../../../helpers/price';
import { SimulatorContext } from '../../../store';
import { H6 } from '../../../components/Typography/styles';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { BsChevronBarUp, BsCheck, BsInfo, BsPersonCheck, BsBoxArrowUpRight } from 'react-icons/bs';
import { IoWalletOutline } from 'react-icons/io5';
import { BiBasket } from 'react-icons/bi';
import { BsExclamation } from 'react-icons/bs';
import { saveSimulationResult } from '../../../services/simulation';
import { sendSimulationMail } from '../../../services/sendSimulation';
import { clientOnlyRegister, creditRegister } from '../../../services/clientRegistration';
import ModalAction from '../../../components/ModalAction';
import ModalActionSendSimulation from '../../../components/ModalActionSendSimulation';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import ModalInfo from '../../../components/ModalInfo';
import { creditLinesBack, simulatorSteps } from '../../../helpers/enum';
import colors from '../../../assets/styles/colors';
import { DefaultLargeButton, SecondaryLargeButton, TertiaryLargeButton } from '../../../components/Buttons/styles';
import Loader from '../../../components/Loader';
import infoCircle from '../../../assets/images/info-circle.svg';

const OldResultPage = ({ setActiveStep, setLastStep, setShowModal }) => {
  const history = useHistory();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const { simulator, setSimulator } = useContext(SimulatorContext);
  const [showModalInfoCapacity, setShowModalInfoCapacity] = useState(false);
  const [showModalAction, setShowModalAction] = useState(false);
  const [showModalActionSendSimulation, setShowModalActionSendSimulation] = useState(false);
  const [showModalActionCongratulations, setShowModalActionCongratulations] = useState(false);
  const [showModalIdValidation, setShowModalIdValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [idCurrentSimulation, setIdCurrentSimulation] = useState('');
  const [showModalInfoCuota, setShowModalInfoCuota] = useState(false);

  function setCompleteStep() {
    var hasCapacity = checkCapacity();
    if(parseInt(simulator.simulation?.montoMaximoSugerido) > parseInt(simulator.simulation?.montoTotalCredito)){
    if (hasCapacity) {
      setLastStep(simulatorSteps.RESULT);
      setActiveStep(simulatorSteps.CLIENT_DATA);
    } else {
      setShowModalInfoCapacity(true);
    }
  }else{
    setShowModalInfoCuota(true);
  }
  }

  function checkCapacity() {
    return parseInt(simulator.simulation.remanenteEstimado) > 0 &&
      parseInt(simulator.simulation.montoMaximoSugerido) >= parseInt(simulator.simulation.remanenteEstimado);
  }

  function closeModalAction() {
    setShowModalAction(false);

    window.location.reload();
  }

  function closeModalActionSendSimulation() {
    setShowModalActionSendSimulation(false);

    window.location.reload();
  }

  function sendSimulation() {
    setShowModalAction(false);
    setShowModalActionSendSimulation(true);
  }

  function sendSimulationBody(emaildata) {
    const req = {
      idSimulacion: history.location.idSimulation ? history.location.idSimulation : idCurrentSimulation,
      email: emaildata
    };
    return req;
  }

  /*useEffect(() => {
    setIsLoading(true);
    initializedStateComponent();
    setIsLoading(false);
  }, []);

  async function initializedStateComponent(){
    const isPricingResponse = await isPricing(simulator.desk.id);
    setPricing(isPricingResponse.data);
  }*/

  async function onSubmitSimulationMail(data) {
    try {
      setIsLoading(true);
      const req = sendSimulationBody(data.correo);
      await sendSimulationMail(req);
      setIsLoading(false);
      setShowModalActionSendSimulation(false);
      setShowModalActionCongratulations(true);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }

  }

  return (
    <StepFourContainer id="result-step-page">
      {!simulator.pricing && <>
        <StepFourHeaderTitle>
          <StepFourHeaderInfo>Resultado Tasa: {simulator.priceValueToSolicitate.tasa?.nombre}</StepFourHeaderInfo>
        </StepFourHeaderTitle>
        <StepFourContent>
          <StepFourColumn>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <FaRegMoneyBillAlt color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Valor total crédito</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.montoTotalCredito))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={parseInt(simulator.simulation.montoMaximoSugerido) < parseInt(simulator.simulation.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                <BsChevronBarUp color={colors.white} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Monto máximo sugerido <b>*</b></H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <IoWalletOutline color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Cuota corriente</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.cuotaCorriente))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <BiBasket color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Remanente estimado</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.remanenteEstimado))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
          </StepFourColumn>
          <StepFourColumn>
            <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Estudio crédito + IVA</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.estudioCreditoMasIVA))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor de la fianza
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {simulator.simulation.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              {/* <StepFourDisplayValuesRow>
              <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
            </StepFourDisplayValuesRow> */}
            </StepFourDisplayValues>
            {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.gmf))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor compras a girar
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Prima anticipada de seguro
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
            </StepFourDisplayValues>
          </StepFourColumn>

        </StepFourContent>
        <StepFourFooter>
          <StepFourFooterRightSide>
            <StepFourDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</StepFourDisplayValuesRowValue>
          </StepFourFooterRightSide>
        </StepFourFooter>
        <StepFourFooter>
          <StepFourFooterLeftSide>
            <DefaultLargeButton type="button" onClick={() => setActiveStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE)} id="back-step">Volver</DefaultLargeButton>
          </StepFourFooterLeftSide>
          <SecondaryLargeButton type="button" onClick={setCompleteStep} id="next">Siguiente </SecondaryLargeButton>
        </StepFourFooter>
      </>}
      {simulator.pricing && <>

        <StepFourHeader>
          <StepFourHeaderTitle>
            <StepFourHeaderStep>Paso 2/3</StepFourHeaderStep>
            <StepFourHeaderInfo>Resultado opción 1 (Tasa NMV: {simulator.simulation.productPricing?.rate.toFixed(2)}%)
              <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasabaja' />
            </StepFourHeaderInfo>
          </StepFourHeaderTitle>
          <StepFourButtonSimulation onClick={() => setShowModal(true)} id="new-simulation">Nueva simulación</StepFourButtonSimulation>
        </StepFourHeader>
        <StepFourContent>
          <StepFourColumn>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <FaRegMoneyBillAlt color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Valor total crédito</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.montoTotalCredito))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={parseInt(simulator.simulation.montoMaximoSugerido) < parseInt(simulator.simulation.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                <BsChevronBarUp color={colors.white} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Monto máximo sugerido <b>*</b></H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <IoWalletOutline color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Cuota corriente</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.cuotaCorriente))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <BiBasket color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Remanente estimado</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation.remanenteEstimado))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
          </StepFourColumn>
          <StepFourColumn>
            <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Estudio crédito + IVA</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.estudioCreditoMasIVA))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor de la fianza
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {simulator.simulation.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              {/* <StepFourDisplayValuesRow>
              <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
            </StepFourDisplayValuesRow> */}
            </StepFourDisplayValues>
            {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.gmf))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor compras a girar
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Prima anticipada de seguro
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
            </StepFourDisplayValues>
          </StepFourColumn>
        </StepFourContent>
        <br></br>
        <br></br>

        <StepFourHeaderInfo>Resultado opción 2 (Tasa NMV: {simulator.simulation1?.productPricing?.rate.toFixed(2)}%)
          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasaalta' />
        </StepFourHeaderInfo>

        <StepFourContent>
          <StepFourColumn>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <FaRegMoneyBillAlt color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Valor total crédito</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1.montoTotalCredito))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={parseInt(simulator.simulation1.montoMaximoSugerido) < parseInt(simulator.simulation1.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                <BsChevronBarUp color={colors.white} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Monto máximo sugerido <b>*</b></H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1.montoMaximoSugerido))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <IoWalletOutline color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Cuota corriente</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1.cuotaCorriente))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
            <StepFourResultItem>
              <StepFourResultItemIcon background={colors.grayLight}>
                <BiBasket color={colors.textPrimary} size={28} />
              </StepFourResultItemIcon>
              <StepFourResultItemInfo>
                <H6 color={colors.textPrimary}>Remanente estimado</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1.remanenteEstimado))}</H6>
              </StepFourResultItemInfo>
            </StepFourResultItem>
          </StepFourColumn>
          <StepFourColumn>
            <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Estudio crédito + IVA</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1.estudioCreditoMasIVA))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor de la fianza
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {simulator.simulation1.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation1.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              {/* <StepFourDisplayValuesRow>
              <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
            </StepFourDisplayValuesRow> */}
            </StepFourDisplayValues>
            {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
            <StepFourDisplayValues>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1.gmf))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Valor compras a girar
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
              <StepFourDisplayValuesRow>
                <StepFourDisplayValuesRowValue>
                  Prima anticipada de seguro
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                </StepFourDisplayValuesRowValue>
                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
              </StepFourDisplayValuesRow>
            </StepFourDisplayValues>
          </StepFourColumn>

        </StepFourContent>
        <StepFourFooter>
          <StepFourFooterRightSide>
            <StepFourDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</StepFourDisplayValuesRowValue>
          </StepFourFooterRightSide>
        </StepFourFooter>
        <StepFourFooter>
          <StepFourFooterLeftSide>
            <DefaultLargeButton type="button" onClick={() => setActiveStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE)} id="back-step">Volver</DefaultLargeButton>
          </StepFourFooterLeftSide>
          <SecondaryLargeButton type="button" onClick={setCompleteStep} id="next">Siguiente </SecondaryLargeButton>
        </StepFourFooter>
      </>}
      {isLoading && <Loader />}
      
      <ModalInfo
        open={showModalInfoCapacity}
        setShowModal={setShowModalInfoCapacity}
        title="Cliente sin capacidad"
        description="Monto solicitado supera la capacidad del cliente."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      
      <ModalInfo
        open={showModalInfoCuota}
        setShowModal={setShowModalInfoCuota}
        title="La capacidad del cliente es inferior al valor de la cuota"
        description=""
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalAction
        open={showModalAction}
        setShowModal={() => closeModalAction()}
        actionFunctionUpButton={() => history.push('/admin/mis-simulaciones')}
        actionFunctionDownButton={() => sendSimulation()}
        title="¡Simulación guardada exitosamente!"
        actionLabelFunctionUpButton="Mis simulaciones"
        actionLabelFunctionDownButton={
          <>
            Compartir Simulación
            <BsBoxArrowUpRight size={15} color={colors.black} style={{ "margin-left": "5px", "margin-bottom": "-2px" }} />
          </>}
        description="Puedes revisar las simulaciones en el siguiente botón o en el menú principal"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} id="check-icon" />} />

      <ModalActionSendSimulation
        open={showModalActionSendSimulation}
        setShowModal={() => closeModalActionSendSimulation()}
        actionFunctionDownButton={() => closeModalActionSendSimulation()}
        onSubmit={onSubmitSimulationMail}
        title="Comparte la simulación con el cliente"
        description="Confirma el correo electrónico del cliente y envía la cotización."
        defaultMail={simulator.clientData.email}
        backgroundIcon={colors.shadow}
        bodyIcon={<BsInfo size={32} color={colors.bgPrimary} />} />

      <ModalActionCongratulations
        open={showModalActionCongratulations}
        setShowModal={setShowModalActionCongratulations}
        actionFunctionUpButton={() => history.push('/admin/dashboard')}
        title="Simulación enviada exitosamente"
        actionLabelFunctionUpButton="Mis solicitudes"
        description="Recuerda comunicarle al cliente revisar la bandeja de entrada del correo, como bandeja de spam en caso que no la pueda visualizar, esta irá como documento adjunto en formato PDF."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />

      <Tooltip
        id='tooltip-prima'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Prima anticipada de seguro
        </TooltipTitle>
        <TooltipContent>
          Seguro de vida destinado a respaldar el pago de la obligación crediticia en caso de muerte o pérdida de la capacidad laboral total o permanente del titular del crédito, el cual se cobra por anticipado y cubre los primeros 24 meses.
        </TooltipContent>
      </Tooltip>

      <Tooltip
        id='tooltip-fianza'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Valor de la fianza
        </TooltipTitle>
        <TooltipContent>
          Figura que cubre la obligación en caso tal de que el cliente incumpla con sus pagos, de acuerdo a condiciones del servicio.
        </TooltipContent>
      </Tooltip>

      <Tooltip
        id='tooltip-compras'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Valor compras a girar
        </TooltipTitle>
        <TooltipContent>
          Corresponde al valor de las compras de cartera.
        </TooltipContent>
      </Tooltip>

      <Tooltip
        id='tooltip-tasaalta'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Opción 2
        </TooltipTitle>
        <TooltipContent>
          Perfil de riesgo negativo con la mejor tasa del grupo al que queda asignado.
        </TooltipContent>
      </Tooltip>

      <Tooltip
        id='tooltip-tasabaja'
        effect="solid"
        place='top'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          Opción 1
        </TooltipTitle>
        <TooltipContent>
          Perfil de riesgo positivo con la mejor tasa del grupo al que queda asignado.
        </TooltipContent>
      </Tooltip>

    </StepFourContainer>
  )
}

export default OldResultPage
